import { cmsFetch } from "@jambushrushti/services/adminAuth";

export interface PublicGuruvani {
  id: string;
  title: string;
  content: string | null;
  category: string | null;
  source: string | null;
  tags: string;
  status: string;
  is_published: boolean;
  is_restricted: boolean;
  image_url?: string | null;
  date?: string | null;
  created_at?: string;
  updated_at?: string;
}

type ApiRecord = Record<string, unknown>;

const baseUrl = import.meta.env.DEV
  ? "/jambushrusti-api"
  : (
      import.meta.env.VITE_API_BASE_URL ||
      "https://api.jambushusti.universal-software.in/api"
    ).replace(/\/$/, "");

const endpoint = `${baseUrl}/jambushrusti/cms/guruvani/`;

function normalize(record: ApiRecord): PublicGuruvani {
  const status = String(
    record.status || (record.is_published ? "Published" : "Draft")
  );

  return {
    id: String(record.id || record.uuid || ""),
    title: String(record.title || "Untitled teaching"),
    content: record.content == null ? null : String(record.content),
    category: record.category == null ? null : String(record.category),
    source: record.source == null ? null : String(record.source),
    tags: Array.isArray(record.tags)
      ? record.tags.join(", ")
      : String(record.tags || ""),
    status,
    is_published:
      status.toLowerCase() === "published" || record.is_published === true,
    is_restricted:
      record.is_restricted_access === true || record.is_restricted === true,
    image_url: record.image_url == null ? null : String(record.image_url),
    date: record.created_at == null ? null : String(record.created_at),
    created_at:
      record.created_at == null ? undefined : String(record.created_at),
    updated_at:
      record.updated_at == null ? undefined : String(record.updated_at),
  };
}

export async function fetchPublicGuruvani(
  signal?: AbortSignal
): Promise<PublicGuruvani[]> {
  const items: PublicGuruvani[] = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const response = await cmsFetch(`${endpoint}?page=${page}`, { signal });
    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(
        payload?.detail || payload?.message || "Unable to load Guruvani."
      );
    }

    const payload = await response.json();
    const data = payload.data ?? payload;
    const rows: ApiRecord[] = Array.isArray(data) ? data : data.results;
    if (!Array.isArray(rows)) {
      throw new Error("The Guruvani response could not be read.");
    }

    for (const row of rows) {
      const item = normalize(row);
      if (item.is_published && !item.is_restricted) {
        items.push(item);
      }
    }

    hasNext = Boolean(data.links?.next ?? data.next);
    page += 1;
  }

  return items;
}
